<template>
    <div>
        <div
            class="row no-gutters"
            style="background: linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url('/images/WCPG_Building.png'); height: 30vh; position: relative; background-position: center; background-size: cover; border-bottom: 2px solid white;"
        >
            <h1
                class="ml-3 text-light"
                style="position: absolute; bottom: 2rem; left: 2rem;"
            >
                Contact
            </h1>
        </div>
        <div class="row p-2 mt-2 no-gutters">
            <div class="col-lg-4 offset-lg-2 p-5">
                <success v-if="success">
                    Your message has been sent !!!
                </success>

                <form>
                    <p>
                        Please enter your information in the form below to
                        submit any questions or comments for us to review. Here
                        at West Chester Protective Gear®, we are happy to
                        provide an excellent customer experience as well as
                        making sure we get your questions answered as soon as
                        possible.
                    </p>
                    <div class="form-group">
                        <label
                            for="name"
                            class="font-weight-bold mb-0 text-uppercase"
                            >* Name:</label
                        >
                        <input
                            type="text"
                            name="name"
                            class="form-control"
                            v-model="user.name"
                            :class="[{ 'is-invalid': errorFor('name') }]"
                        />
                        <v-errors :errors="errorFor('name')"></v-errors>
                    </div>
                    <div class="form-group">
                        <label
                            for="email"
                            class="font-weight-bold mb-0 text-uppercase"
                            >* Email:</label
                        >
                        <input
                            name="email"
                            type="email"
                            class="form-control"
                            v-model="user.email"
                            :class="[{ 'is-invalid': errorFor('email') }]"
                        />
                        <v-errors :errors="errorFor('email')"></v-errors>
                    </div>
                    <div class="form-group">
                        <label
                            for="subject"
                            class="font-weight-bold mb-0 text-uppercase"
                            >* Subject:</label
                        >
                        <input
                            name="subject"
                            type="text"
                            class="form-control"
                            v-model="user.subject"
                            :class="[{ 'is-invalid': errorFor('subject') }]"
                        />
                        <v-errors :errors="errorFor('subject')"></v-errors>
                    </div>
                    <div class="form-group">
                        <label
                            for="message"
                            class="font-weight-bold mb-0 text-uppercase"
                            >* Message:</label
                        >
                        <textarea
                            name="message"
                            type="text"
                            class="form-control"
                            cols="30"
                            rows="10"
                            v-model="user.message"
                            :class="[{ 'is-invalid': errorFor('message') }]"
                        ></textarea>
                        <v-errors :errors="errorFor('message')"></v-errors>
                    </div>
                    <button class="btn-round-red pt9rem" @click.prevent="sendMsg">
                        SEND
                    </button>
                </form>
            </div>
            <div class="col-md-6 col-lg-4 p-5">
                <div>
                    <p>
                        <img
                            src="/images/img-flag-usa.gif"
                            style="height: 14px;"
                            alt=""
                        />
                        <strong>West Chester Protective Gear</strong><br />
                        11500 Canal Road<br />
                        Cincinnati, OH 45241<br />
                        <a class="text-dark" href="tel:8006471900"
                            >(800) 969-7562</a
                        >
                    </p>
                </div>
                <div>
                    <p>
                        <img
                            src="/images/img-flag-usa.gif"
                            style="height: 14px;"
                            alt=""
                        />
                        <strong>PIP Global Corporate Headquarters</strong><br />
                        25 British American Blvd.<br />
                        Latham, NY 12110<br />
                        <a class="text-dark" href="tel:8006471900"
                            >800-262-5755</a
                        >
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import validationErrors from "./../mixins/validationErrors";
export default {
    mixins: [validationErrors],
    data() {
        return {
            user: {
                name: null,
                email: null,
                subject: null,
                message: null
            },
            success: false,
            errors: null
        };
    },
    methods: {
        async sendMsg() {
            this.errors = null;
            try {
                await axios.post(`/api/sendMsg`, this.user).then(response => {
                    this.success = true;
                    var self = this;
                    setTimeout(function() {
                        self.success = false;
                    }, 3000);
                    this.user = {};
                });
            } catch (error) {
                this.errors = error.response && error.response.data.errors;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
h1 {
    font-family: "Oswald", Helvetica, Arial, sans-serif;
    font-size: 3.5rem;
}
label {
    font-family: "Acumin Pro", Helvetica, Arial, sans-serif;
}
.contact {
    padding: 3rem 2rem;
    @media screen and (max-width: 1604px) {
        padding: 3rem 0.5rem;
    }
}
</style>
